export default __webpack_public_path__ + "static/media/1200px-Java_programming_language_logo.svg.4292f184.png";